module.exports = __webpack_public_path__ + "img/expovina_05_full.b683d86b.jpg";